import { render, staticRenderFns } from "./CariTahsilat.vue?vue&type=template&id=14fb7670&"
import script from "./CariTahsilat.vue?vue&type=script&lang=js&"
export * from "./CariTahsilat.vue?vue&type=script&lang=js&"
import style0 from "./CariTahsilat.vue?vue&type=style&index=0&id=14fb7670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports